import { render } from "./ProductsWrapper.vue?vue&type=template&id=101d7d08&ts=true"
import script from "./ProductsWrapper.vue?vue&type=script&lang=ts"
export * from "./ProductsWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__